export const COUNTDOWN_TIMER_START = 5; // @TODO env?
export const WSP_DEBUG = false; // @TODO env?
export const ESP_DEBUG = false; // @TODO env?

export const transformErrorMessage = (error: Error): string => {
  let message = error.message;

  if (message.includes(': ')) {
    const colonIndex = message.indexOf(': ');
    const prefix = message.substring(0, colonIndex);
    const messageAfterColon = message.substring(colonIndex + 2); // +2 to skip ": "

    const statusTexts = ['Bad Request', 'Unauthorized', 'Forbidden', 'Not Found', 'Internal Server Error'];

    // Only strip the status text prefix if there's actual content after it
    // If there's no message after the colon, keep the status text
    if ((statusTexts.includes(prefix) || prefix.trim() === '') && messageAfterColon.trim() !== '') {
      message = messageAfterColon;
    }
  }

  return message;
};

const hasMessageProperty = (error: unknown): error is { message: unknown } => {
  return typeof error === 'object' && error !== null && 'message' in error;
};

export const transformAnyError = (error: Error | string | unknown): string => {
  let message = '';

  if (error instanceof Error) {
    message = transformErrorMessage(error);
  } else if (typeof error === 'string') {
    if (error.startsWith('Bad Request: ')) {
      message = error.replace('Bad Request: ', '');
    } else {
      message = error;
    }
  } else if (hasMessageProperty(error) && typeof error.message === 'string') {
    // Handle API error objects with message property
    message = error.message;
  } else {
    message = String(error);
  }

  // Return a default message if the error message is empty
  if (message === '' || message.trim() === '') {
    return 'An error occurred. Please try again.';
  }

  return message;
};
